import { useTranslation } from 'react-i18next'
import type { GoalStatus } from 'core/api/current-week/useApiGetCurrentWeekGoalIndicators'

interface GoalStatusLabelProps {
  goalStatus: GoalStatus
}

const getLabelTranslationKey = (goalStatus: GoalStatus) => {
  switch (goalStatus) {
    case 'BAD':
      return 'general.homepage.weekly-goal.status-bad'
    case 'MEDIUM':
      return 'general.homepage.weekly-goal.status-medium'
    case 'GOOD':
      return 'general.homepage.weekly-goal.status-good'
  }
}

const GoalStatusLabel = ({ goalStatus }: GoalStatusLabelProps) => {
  const { t } = useTranslation()

  return (
    <div className={`vp-body-l mg-weekly-goal-status-label__${goalStatus?.toLowerCase()}`}>
      {t(getLabelTranslationKey(goalStatus))}
    </div>
  )
}

export default GoalStatusLabel
